export default "__VITE_ASSET__owDZluo8NDg9LkLD337N_w__"